import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { PncCentralCallService } from './pnc-central-call.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'pnc-central-call',
    imports: [MatProgressSpinnerModule],
    templateUrl: './pnc-central-call.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './pnc-central-call.component.scss'
})
export class PncCentralCallComponent implements OnInit, OnDestroy {
    showSpinner = false;
    showMessage = false;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private router: Router,
        private _pncCentralCallService: PncCentralCallService
    ) {}

    ngOnInit(): void {
        // https://adele.test.almaphil.de/pnc-central-call/18028050/external-id/99123456

        this.showSpinner = true;
        this.showMessage = false;
        const url = this.router.url.split('/');
        const profileId = url[2];
        const externalId = url[4];

        console.log(profileId, externalId);

        this._pncCentralCallService.callPNC(profileId, externalId).subscribe(
            () => {
                console.log('Sucessfully called');
                this.showSpinner = false;
                this.showMessage = true;
            },
            () => {
                console.log('Something went wrong.');
                this.showSpinner = false;
                this.showMessage = false;
            }
        );
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
